import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import isNaN from 'lodash/isNaN';
import { ErrorBoundary } from '@els/els-react--utils';
import GoToPage from '@Components/GoToPage/GoToPage';
import { Paginator } from '@els/els-react--paginator';

import './Pagination.scss';

function Pagination({ totalPages, currentPage, onSelect, totalItems, shouldDisplayGoToPage, resultsPerPage }) {
  const [isMobileView, setIsMobileView] = useState(globalThis.innerWidth <= 768);

  useEffect(() => {
    if (typeof globalThis.matchMedia !== 'function') {
      return undefined;
    }

    const mediaQuery = globalThis.matchMedia('(max-width: 768px)');
    const handleChange = (e) => setIsMobileView(e.matches);
    const legacyAddListener = mediaQuery ? Reflect.get(mediaQuery, 'addListener') : undefined;
    const legacyRemoveListener = mediaQuery ? Reflect.get(mediaQuery, 'removeListener') : undefined;

    if (!mediaQuery) {
      return undefined;
    }

    setIsMobileView(mediaQuery.matches);
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleChange);
    } else if (typeof legacyAddListener === 'function') {
      legacyAddListener.call(mediaQuery, handleChange);
    }

    return () => {
      if (typeof mediaQuery.removeEventListener === 'function') {
        mediaQuery.removeEventListener('change', handleChange);
      } else if (typeof legacyRemoveListener === 'function') {
        legacyRemoveListener.call(mediaQuery, handleChange);
      }
    };
  }, []);
  const selectPage = (value) => {
    const page = Number.parseInt(value, 10);

    if (!isNaN(page) && page <= totalPages && page > 0 && page !== currentPage) {
      onSelect(page);
    }
  };

  // Paginator doesn't catch its own errors, although it is wrapped in makeErrorBoundComponent.
  // So added explicit ErrorBoundary here, just in case, because there are other error that potentially can be thrown by it.
  return (
    <div className="o-els-flex-layout o-els-flex-layout--left o-els-flex-layout--wrap pagination-controls">
      {totalItems && currentPage <= totalPages && (
        <ErrorBoundary>
          <Paginator
            onPageChange={selectPage}
            resultsPerPage={resultsPerPage}
            totalResults={Number.parseInt(totalItems, 10)}
            currentPage={currentPage}
            a11y={{ name: 'Results page pagination' }}
            isMobileView={isMobileView}
          />
        </ErrorBoundary>
      )}
      {shouldDisplayGoToPage && <GoToPage chunksCount={totalPages} onClick={selectPage} />}
    </div>
  );
}

Pagination.propTypes = {
  resultsPerPage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
  totalItems: PropTypes.number.isRequired,
  shouldDisplayGoToPage: PropTypes.bool,
};

export default Pagination;
